import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCY: CultureInfo = {
  name: 'en-CY',
  displayName: 'English (Cyprus)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CY',
  parent: CultureInfoEn
};
